<button class="back-button" (click)="onBackClicked()">
  <tngh-svg-icon [style.color]="'white'" name="arrow-left" size="2xl" />
  <span>Terug</span>
</button>
<app-character-choice [characters]="characters" (fieldClicked)="onFieldClicked($event)" />
